export default __webpack_public_path__ + "static/media/image_3.54469a46.jpg";